import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpaceDashboardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"space_dashboard"}/>
}
